import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { BookOpen, X } from "lucide-react";
import { readerApi, readerToken } from "@/lib/readerApi";

export const ResumeBanner = () => {
  const [info, setInfo] = useState(null);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (!readerToken.get()) return;
    readerApi.me().then(setInfo).catch(() => { /* not a valid session; stay hidden */ });
  }, []);

  const show = info && !hidden;
  const page = (info?.lastLesson || 0) + 1;
  const first = info?.name ? info.name.split(" ")[0] : "";

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className="resume-banner"
          data-testid="resume-banner"
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.4, ease: [0.2, 0.7, 0.2, 1] }}
        >
          <BookOpen size={16} className="resume-icon" />
          <span className="resume-text">Welcome back{first ? `, ${first}` : ""} — your eBook is where you left it</span>
          <Link to="/read" className="resume-cta" data-testid="resume-continue">Continue · Page {page}</Link>
          <button className="resume-close" onClick={() => setHidden(true)} aria-label="Dismiss" data-testid="resume-dismiss"><X size={14} /></button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
